import { useDispatch } from 'react-redux'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { DashboardTypes } from 'features/Codes'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useAlert } from 'features/dialog/Alert'
import ad from 'api/axios/foka/ad'
import Button from 'components/form/Button'
import Icon from 'components/Icon'
import NoneAnchor from 'components/NoneAnchor'
import PropTypes from 'prop-types'
import AdGroupSelectModal from 'features/dashboard/operation/adGorupSelect/AdGroupSelectModal'
import { showAdGroupSelect } from 'features/dashboard/operation/adGorupSelect/adGroupSelectSlice'
import { DASHBOARD_REFERRER } from 'features/ad/useDashboardReferrer'
import { fail } from '../../../toast/Toast'

const CreateKeywordButton = ({ type = 'button' }) => {
  const dispatch = useDispatch()
  const { accountId } = useParams()
  const { selectedIds } = useDashboardTableSelector(DashboardTypes.AD_GROUP)
  const history = useHistory()
  const [disabled, setDisabled] = useState(false)
  const [FailedAlert, showFailedAlert] = useAlert()
  const createKeyword = async ({ adGroupId }) => {
    setDisabled(true)
    try {
      const {
        data: { generable },
      } = await ad.getKeywordsGenerable(adGroupId)
      if (generable === false) {
        showFailedAlert()
      } else {
        await ad
          .getAdGroup(adGroupId)
          .then(
            ({
              data: {
                adGroupDto: { campaignId },
              },
            }) => {
              history.push(
                `/${accountId}/ads/campaigns/${campaignId}/groups/${adGroupId}/addKeywords?from=${DASHBOARD_REFERRER.KEYWORD}`
              )
            }
          )
          .catch(error => {
            if (error.response?.data?.errorCode === 104007) {
              fail('삭제된 광고그룹 입니다.')
            } else {
              fail('알 수 없는 에러가 발생했습니다')
            }
          })
      }
    } catch (e) {
      fail('알 수 없는 에러가 발생했습니다')
      return
    }
    setDisabled(false)
  }

  const handleCreate = () => {
    if (selectedIds.length === 1) {
      const [adGroupId] = selectedIds
      createKeyword({ adGroupId })
    } else {
      dispatch(showAdGroupSelect())
    }
  }
  return (
    <>
      {type === 'button' ? (
        <Button primary disabled={disabled} onClick={handleCreate}>
          <Icon className="img_comm" name="add" />
          키워드 만들기
        </Button>
      ) : (
        <NoneAnchor
          className="link_txt"
          onClick={handleCreate}
          style={disabled ? { pointerEvents: 'none' } : undefined}>
          키워드 만들기
        </NoneAnchor>
      )}
      <AdGroupSelectModal
        type={DashboardTypes.KEYWORD}
        handleCreate={createKeyword}
      />
      <FailedAlert title="키워드 제한수 초과">
        개수 제한으로 키워드 만들기를 할 수 없습니다.
        <br />
        키워드 삭제후 다시 진행하세요.
      </FailedAlert>
    </>
  )
}
CreateKeywordButton.propTypes = {
  type: PropTypes.oneOf(['button', 'link']),
}
export default CreateKeywordButton
